export default "__VITE_ASSET__B$j_3RtK__"